import { LS_PARTNER_PROGRAMS } from '@config/localstorage.js'
import { useLocalStorage } from '@vueuse/core'
import { isArray } from '@helpers/utils.js'
import { computed, ref } from 'vue'

const partnerProgramStore = useLocalStorage(LS_PARTNER_PROGRAMS, [])
export const gameIDsRefreshed = ref({})

export default function () {
  function isInPartnerProgram(gameId) {
    return computed(
      () =>
        gameId &&
        isArray(partnerProgramStore.value) &&
        partnerProgramStore.value.includes(gameId)
    )
  }

  function addPartnerProgram(gameId) {
    if (isArray(partnerProgramStore.value)) {
      partnerProgramStore.value = [...partnerProgramStore.value, gameId]
    } else {
      partnerProgramStore.value = [gameId]
    }
  }

  function removePartnerProgram(gameId) {
    if (isArray(partnerProgramStore.value)) {
      partnerProgramStore.value = partnerProgramStore.value.filter(
        (id) => id !== gameId
      )
    } else {
      partnerProgramStore.value = []
    }
  }

  function clearPartnerPrograms() {
    partnerProgramStore.value = []
  }

  return {
    clearPartnerPrograms,
    removePartnerProgram,
    isInPartnerProgram,
    addPartnerProgram,
  }
}
